module.exports = __webpack_public_path__ + "static/media/opensea.cd23760a.jpg";